import MoveWrapper from '../moveWrapper';
import Button from '../button';

export default function(obj, _Vdt, blocks, $callee) {
    _Vdt || (_Vdt = Vdt);
    obj || (obj = {});
    blocks || (blocks = {});
    var h = _Vdt.miss.h, hc = _Vdt.miss.hc, hu = _Vdt.miss.hu, widgets = this && this.widgets || {}, _blocks = {}, __blocks = {},
        __u = _Vdt.utils, extend = __u.extend, _e = __u.error, _className = __u.className, __slice = __u.slice, __noop = __u.noop,
        __m = __u.map, __o = __u.Options, _getModel = __o.getModel, _setModel = __o.setModel,
        _setCheckboxModel = __u.setCheckboxModel, _detectCheckboxChecked = __u.detectCheckboxChecked,
        _setSelectModel = __u.setSelectModel,
        self = this.data, $this = this, scope = obj, Animate = self && self.Animate, parent = ($callee || {})._super;

    const {
    children, value, trigger, showArrow, confirm,
    canHover, className, _feedback, transition,
    container, theme, disabled, always, size,
} = self.get();

const events = {};
if ((canHover || confirm) && trigger === 'hover' && !always) {
    events['ev-mouseenter'] = self.show;
    events['ev-mouseleave'] = self.hide.bind(self, false);
}

const classNameObj = {
    "k-dropdown-menu": true,
    "k-tooltip-content": true, 
    'k-cannot-hover': trigger === 'hover' && !canHover && !confirm,
    [className]: className,
    [`k-${theme}`]: true,
    [`k-${size}`]: size !== 'default',
};

    return h(MoveWrapper, {
        'container': function() {try {return (container )} catch(e) {_e(e)}}.call($this),
        'children': h(Animate, {
            'a:show': function() {try {return (value && !disabled && !self.isEmptyChildren )} catch(e) {_e(e)}}.call($this),
            'className': _className(function() {try {return (classNameObj )} catch(e) {_e(e)}}.call($this)),
            'a:transition': function() {try {return (transition )} catch(e) {_e(e)}}.call($this),
            'ref': function(i) {widgets['menu'] = i},
            ...function() {try {return (events )} catch(e) {_e(e)}}.call($this),
            'a:delayDestroy': function() {try {return (false )} catch(e) {_e(e)}}.call($this),
            'a:enterStart': function() {try {return (self._onShow )} catch(e) {_e(e)}}.call($this),
            'children': [
                function() {try {return (showArrow )} catch(e) {_e(e)}}.call($this) ?
                    h('i', null, null, _className(function() {try {return ({
                "k-arrow": true,
                [`k-${_feedback[_feedback.important]}`]: _feedback.important,
            } )} catch(e) {_e(e)}}.call($this)), null, function(i) {widgets['arrow'] = i}) :
                    undefined,
                function() {try {return (children )} catch(e) {_e(e)}}.call($this),
                function() {try {return (confirm )} catch(e) {_e(e)}}.call($this) ?
                    h('div', null, (_blocks['buttons'] = function(parent) {
                        return [
                            h(Button, {
                                'size': 'small',
                                'children': function() {try {return (self.get('cancelText') )} catch(e) {_e(e)}}.call($this),
                                '_context': $this,
                                'ev-click': function() {try {return (self._cancel )} catch(e) {_e(e)}}.call($this)
                            }),
                            h(Button, {
                                'type': 'primary',
                                'size': 'small',
                                'children': function() {try {return (self.get('okText') )} catch(e) {_e(e)}}.call($this),
                                '_context': $this,
                                'ev-click': function() {try {return (self._ok )} catch(e) {_e(e)}}.call($this)
                            })
                        ];
                    }) && (__blocks['buttons'] = function(parent) {
                        var args = arguments;
                        return blocks['buttons'] ? blocks['buttons'].apply($this, [function() {
                            return _blocks['buttons'].apply($this, args);
                        }].concat(__slice.call(args, 1))) : _blocks['buttons'].apply($this, args);
                    }) && __blocks['buttons'].apply($this, [__noop]), 'k-buttons') :
                    undefined
            ],
            '_context': $this,
            'ev-a:leaveStart': function() {try {return (self._removeDocumentEvents )} catch(e) {_e(e)}}.call($this),
            'ev-mousedown': function() {try {return (self._onMouseDown )} catch(e) {_e(e)}}.call($this)
        }),
        '_context': $this
    })
}